// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__17-Ex","legacyBtn":"MutateMid_legacyBtn__22Sy3"};